










































import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
// import NewVoteButton from '@/components/next/NewVoteButton.vue';
import NewVoteButton from '../components/VoteButtonNew.vue';
import { Icon, ImagePreview } from 'vant';
import { voteDetail } from '../api';

Vue.use(Icon);
@Component({
  components: {
    NewVoteButton,
  },
})
export default class PeopleDetail extends Vue {
  voteName: string = '2023project/q3/2023gygg';
  shareTitle: string = '';
  shareSubtitle: string = '';
  shareCover: string = '';
  item: any = {};
  showtype: string = '';
  source: string = '1';
  async activated() {
    const type = this.$route.query.type as string;
    this.source = type;
    if (type === '1') {
      this.showtype = require('../assets/cr.png');
    } else if (type === '2') {
      this.showtype = require('../assets/qsn.png');
    }
    const res: any = await voteDetail(this.$route.query.id as string);
    this.item = res.data;
    this.onRouteChange(res.data);
  }

  onRouteChange(data: any) {
    // 设置分享文案
    const cover = this.shareCover;
    // App分享
    this.$appShareInfo({
      title: data.share_title,
      url: location.href,
      subtitle: data.share_subtitle,
      classId: -1,
      id: -1,
      image: data.share_cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: data.share_title,
        subtitle: data.share_subtitle,
        image: data.share_cover,
      });
    }
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  votSuccess(data: any, index: any) {
    this.item.votes = data;
    this.$emit('like');
  }
}
